import * as ibantools from 'ibantools'

export const handleValidateIban = (iban) => {
	return ibantools.isValidIBAN(iban)
}

export const handleValidateBic = (bic) => {
	return ibantools.isValidBIC(bic)
}
